/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsEnergy: {
  name: 'energy';
  data: string;
} = {
  name: 'energy',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.349 1.063a1 1 0 0 1 .643 1.061L13.132 9H19a1 1 0 0 1 .832 1.555l-8 12a1 1 0 0 1-1.824-.68l.86-6.875H5a1 1 0 0 1-.832-1.555l8-12a1 1 0 0 1 1.18-.382ZM6.869 13H12a1 1 0 0 1 .992 1.124l-.474 3.797L17.13 11H12a1 1 0 0 1-.992-1.124l.474-3.797L6.87 13Z" fill="currentColor"/></svg>`,
};
